import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import Button from "../../../../components/Button";
import Loader from "../../../../components/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MultiFactorError, MultiFactorResolver, getMultiFactorResolver, signInWithEmailAndPassword, PhoneMultiFactorInfo } from "firebase/auth";
import { auth } from "../../../../firebase/firebase";
import APILoader from "../../../../components/APILoader";

const Step1 = () => {
  let resolver: MultiFactorResolver;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  // const [maskedPhone, setMaskedPhone] = useState("");

  const navigate = useNavigate();
  const [updatingUser, setUpdatingUser] = useState(false);

  const schema = Yup.object().shape({
    email: Yup.string().email().required(`Email is required!`),
    password: Yup.string().required(`Password is required!`).min(8),
  });

  const isPhoneMultiFactorInfo = (hint: any): hint is PhoneMultiFactorInfo => {
    return (hint as PhoneMultiFactorInfo).phoneNumber !== undefined;
  };

  useEffect(() => {
    const validate = async (data: { [key: string]: string | undefined }) => {
      try {
        await schema.validate(data, { abortEarly: true });
        setErrors({});
        setIsFormValid(true);
      } catch (err) {
        const validationErrors: { [key: string]: string } = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach(err => {
            if (err.path) {
              validationErrors[err.path] = err.message;
            }
          });
        }
        setErrors(validationErrors);
        setIsFormValid(false);
      }
    };
    validate({ email, password });
  }, [email, password]);

  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    let maskedPhone = "";
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      const authError = error as MultiFactorError;
      if (authError.code === "auth/multi-factor-auth-required") {
        resolver = getMultiFactorResolver(auth, authError);
        const phones = resolver.hints.filter(isPhoneMultiFactorInfo).map(phoneHint => phoneHint.phoneNumber);
        // setMaskedPhone(phones[0]);
        maskedPhone = phones[0];
        window.resolver = resolver;
      } else if (authError.code === "auth/too-many-requests") {
        resolver = getMultiFactorResolver(auth, authError);
        window.resolver = resolver;
      } else {
        console.log(authError.code, authError.message);
        toast.error("Invalid Credentials");
        return;
      }
    }
    window.localStorage.setItem("approvedsignin", JSON.stringify(true));
    navigate("/verifyPhone", { state: { maskedPhone } });
  };

  // const isValid = () => {
  //   return Object.keys(errors).length === 0;
  // };

  useEffect(() => {
    setErrors({ email: "", password: "" });
    return () => {};
  }, []);

  const onBlurMe = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    const isValid = await validateForm(name, value);
  };
  const validateForm = async (name: string, value: string) => {
    try {
      await schema.validateAt(name, { [name]: value });

      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  return (
    <>
      {/* {updatingUser && <Loader />} */}
      <APILoader loading={updatingUser} />
      <section>
        <div className="container">
          <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
            {/* Left Container */}
            <div className="flex flex-col items-start justify-start">
              <h1 className="herotitle">Skarvo</h1>
              <p className="text-xl font-normal">Log In to your Skarvo Business account.</p>
            </div>

            {/* Right Container */}
            <div className="flex flex-col gap-10">
              <div className="flex flex-col items-start formcard">
                <div className="flex flex-row items-start formheader">
                  <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Log In</div>
                </div>
                <div className="px-[30px] flex flex-col space-x-[10x] w-full">
                  <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Email"
                    required
                    onChange={e => setEmail(e.target.value)}
                    onBlur={onBlurMe}
                  />
                  <span className="block h-5 mb-2 text-sm text-red-600 dark:text-red-500">{errors.email ?? " "}</span>
                  <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Password
                  </label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Password"
                    required
                    onChange={e => setPassword(e.target.value)}
                    onBlur={onBlurMe}
                  />
                  <span className="block h-5 mb-2 text-sm text-red-600 dark:text-red-500">{errors.password ?? " "}</span>
                </div>

                <div className="flex justify-center w-full px-[30px] mb-[30px]"></div>
                <div className="thickseparator"></div>
                <div className="flex flex-col items-center justify-between w-full p-[30px] md:flex-row-reverse  gap-y-[30px]">
                  <Button
                    to="/verify"
                    onClick={handleSubmit}
                    className="w-full md:w-auto md:min-w-[120px] formprimarybutton"
                    isDisabled={!isFormValid}
                  >
                    Continue
                  </Button>
                  <Link to="/resetPassword" className="w-full md:w-auto md:min-w-[180px] formsecondarybutton">
                    Forgot Password?
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div id="2fa-captcha" className="flex justify-center"></div>
          <ToastContainer />
        </div>
      </section>
    </>
  );
};

export default Step1;
